/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactRestService, ContactType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { RouteDataService, SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ContactListFilter, contactListFilterToDto, filterAllowedContactTypes } from './contact-list-filter.model';
import { ContactListInit } from './contact-list-init.model';
import { ContactListItem } from './contact-list-item.model';
import { ID } from '@gh/common-shared-data';
import { BuilderUserContext, FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class ContactListBusinessService implements InitViewService {
  constructor(private dictionaryService: DictionaryService,
              private routeData: RouteDataService,
              private userContext: BuilderUserContext,
              private contactRest: ContactRestService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    let filterName;
    if (this.userContext.masterView) {
      filterName = FilterNames.contactsMaster;
    } else if (this.userContext.corporateView) {
      filterName = FilterNames.contactsCorp;
    } else {
      filterName = FilterNames.contacts;
    }
    return {
      init: this.getInit(),
      contactTypes: this.dictionaryService.getByEnum(ContactType),
      gridLayout: this.gridLayoutService.get('contacts'),
      filter: this.filterService.get(filterName),
      filterName,
    };
  }

  getInit(): Observable<ContactListInit> {
    return this.contactRest.getInit();
  }

  findAllAsDataSource(filter: ContactListFilter, init: ContactListInit): SlicedDataSource<ContactListItem> {
    return this.contactRest.findAllAsDataSource(contactListFilterToDto(filterAllowedContactTypes(filter, init)));
  }

  validate(id: ID): Observable<any> {
    return this.contactRest.validate(id);
  }
}
